// Actions constants should be mapped in the same order
// as they are defined in the actions file.
export const ACTIONS = {
  SET_ACTIVE_ORDERS_COUNT: 'set_active_orders_count',
  SET_SHOPPING_LIST_COUNT: 'set_shopping_list_count'
};
